export default "__VITE_ASSET__C3aMHtlK__"